import { useTranslation } from 'react-i18next';

import { MicrophoneOutline } from '@bonusly/design-system';
import { useDispatch } from '@bonusly/events';

import { useActionInput } from '../../context';
import { AudioRecordingEvent } from '../../events';
import { useIsEnabled } from '../../hooks/use-is-enabled';
import { DecorationButton } from './decoration-button';

interface RecordAudioButtonProps {
	decorationVariant?: 'default' | 'list-item';
}

export const RecordAudioButton = ({ decorationVariant = 'default' }: RecordAudioButtonProps) => {
	const isEnabled = useIsEnabled('audio-recording');
	const { t } = useTranslation('action_input');
	const dispatch = useDispatch();
	const { context } = useActionInput();

	if (!isEnabled) {
		return null;
	}

	const openAudioRecordingModal = () => {
		dispatch(AudioRecordingEvent.OpenModal, { contextType: context });
	};

	return (
		<DecorationButton label={t('decorations.record_audio_tooltip')} onClick={openAudioRecordingModal} decorationVariant={decorationVariant}>
			<MicrophoneOutline />
		</DecorationButton>
	);
};
